import React, { FunctionComponent, useEffect, useMemo, useState } from "react"
import { Grid, Typography } from "@material-ui/core"
import { FileFormats } from "./FileFormats"
import { useBatchPageContext } from "../useBatchPageContext"
import { DoneModal } from "./DoneModal"
import { Step, useStepControlsContext } from "../../../features/StepControls/useStepControlsContext"
import { StepControls } from "../../../features/StepControls/StepControls"
import { LoadingButton } from "../../../components/LoadingButton"
import styles from "./Approve.module.scss"

export const Approve: FunctionComponent = props => {
    const { state, approveAudio, downloadAudio } = useBatchPageContext()
    const { hide } = useStepControlsContext()
    const [loading, setLoading] = useState(false)
    const [showModal, setShowModal] = useState(false)

    function handleApprove() {
        setLoading(true)
        setShowModal(true)
        approveAudio().then(({ audioFiles, hasErrors }) => {
            if (audioFiles.length > 0) downloadAudio(audioFiles)
            if (hasErrors) setShowModal(false)
            setLoading(false)
        }) // errors caught in context & appended to individual rows
    }

    const canProceed = useMemo(() => {
        return !state.containsOperationErrors && !state.containsValidationErrors && !loading
    }, [state.containsValidationErrors, state.containsOperationErrors, loading])

    useEffect(() => {
        hide(Step.NEXT)
    }, [])

    return (
        <Grid
            container
            alignItems="stretch"
            direction="column"
            spacing={3}
            style={{ width: "100%" }}
        >
            <Grid item data-testid="approve-description" className={styles.Header}>
                <Typography variant="caption">
                    Select the audio format you'd like generated for each audio track. Click SAVE to
                    begin the audio generation process.
                </Typography>
            </Grid>
            <Grid item>
                <Grid container direction="column" spacing={0}>
                    <Grid item className={styles.FormatOptions}>
                        <Typography variant="body1">File Format Options</Typography>
                    </Grid>
                    <Grid item>
                        <FileFormats />
                    </Grid>
                </Grid>
            </Grid>

            <Grid item>
                <Grid container direction="row" spacing={2}>
                    <Grid item>
                        <StepControls />
                    </Grid>
                    <Grid item>
                        <LoadingButton
                            buttonId={"approve-audio-btn"}
                            disabled={loading || !canProceed}
                            loading={loading}
                            text={"Save"}
                            onClick={handleApprove}
                        />
                    </Grid>
                </Grid>
            </Grid>

            <DoneModal show={showModal} loading={loading} />
        </Grid>
    )
}
